import { createSlice } from "@reduxjs/toolkit";
export var mfaDialogState = {
  show: true
};
export var mfaDialogSlice = createSlice({
  name: 'mfaDialog',
  initialState: mfaDialogState,
  reducers: {
    hide: function hide(state) {
      state.show = false;
    }
  }
});